module.exports = __webpack_public_path__ + "img/bgc.3921d612.svg";